export function findErrors(value, requirements, element) {
	let error = {text: '', isOk: true };

	for( let i = 0; i < requirements?.length && error.isOk ; i++) {
		error = requirements[i](value, element);
	}

	return error;
}